import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import ImmunitySalesIndex from './join';

export default function () {
  useEffect(() => {
    navigate('/immunity/join-special/' + location.search);
  }, []);
  return <ImmunitySalesIndex />;
}
